<div class="off-market-remax-radar-cta" [class.off-market-remax-radar-cta--done]="isRadarCTASubmitted">
  <div class="off-market-remax-radar-cta__container">
    <div class="off-market-remax-radar-cta__content-container">
      <div class="off-market-remax-radar-cta__icon off-market-remax-radar-cta--step-one">
          <img [src]="'/assets/icons/listing-details/remax_radar_icon.svg' | staticp">
      </div>
      <div class="off-market-remax-radar-cta__heading off-market-remax-radar-cta--step-one">
        {{'details.stay-in-the-know' | translate}}
      </div>
      <div class="off-market-remax-radar-cta__description off-market-remax-radar-cta--step-one">
        {{'details.save-this-search-description-part-one' | translate}} <br> <b>{{'details.save-this-search-description-part-two' | translate}}</b> {{'details.save-this-search-description-part-three' | translate}}
      </div>
      <div class="off-market-remax-radar-cta__button off-market-remax-radar-cta--desktop off-market-remax-radar-cta--step-one" (click)="showSaveSearchModal = true" (keydown.enter)="showSaveSearchModal = true">
        {{'details.save-this-search' | translate}}
      </div>
      <div class="off-market-remax-radar-cta__button off-market-remax-radar-cta--mobile off-market-remax-radar-cta--step-one" (click)="onSaveSearchClick()" (keydown.enter)="showSaveSearchModal = true">
        {{'details.save-this-search' | translate}}
      </div>
      <div class="off-market-remax-radar-cta__success-icon off-market-remax-radar-cta--step-two">
        <div class="check-mark__circle--echo">
        </div>
        <div class="check-mark__circle">
          <div class="check-mark__top-right-mask">
            <div class="check-mark__top-right-spinner">
            </div>
          </div>
          <div class="check-mark__bottom-right-mask">
            <div class="check-mark__bottom-right-spinner">
            </div>
          </div>
          <div class="check-mark__bottom-left-mask">
            <div class="check-mark__bottom-left-spinner">
            </div>
          </div>
          <div class="check-mark__top-left-mask">
            <div class="check-mark__top-left-spinner">
            </div>
          </div>
          <img class="check-mark__icon" [src]="'/assets/icons/listing-details/checkmark_icon.svg' | staticp">
        </div>
      </div>
      <div class="off-market-remax-radar-cta__success-message off-market-remax-radar-cta--step-two">
        {{'details.save-this-searc-success-message-part-one' | translate}} <br> {{'details.save-this-searc-success-message-part-two' | translate}}
      </div>
    </div>
    <div class="content-wrapper flex-one">
      <app-modal class="hide-on-tablet-down listing-detail-save-search" [shouldShowModal]="showSaveSearchModal" (closeModal)="hideSearchPopup()" [allowOutsideClickToClose]="false" [templateRef]="saveSearchRef">
      </app-modal>
      <ng-template #saveSearchRef>
        <div class="top-level modal-header">
          <h3 class="text-center header-save-search" translate="home.save-search"></h3>
        </div>
        <app-save-search (closed)="hideSearchPopup()" [listing]="listing" [parent]="'remax-radar'"></app-save-search>
      </ng-template>
      <app-notification-popup-modal
        *ngIf="showNoSavedSearchFound"
        (onClose)="showNoSavedSearchFound = false"
        [title]="'no-saved-search.title' | translate"
        [messageText]="'no-saved-search.text' | translate">
      </app-notification-popup-modal>
    </div>
  </div>

</div>
